<template>
    <ThePage>
        <template v-slot:title>
            <div class="d-flex flex-row">
                <div class="w-100">Отчет продаж</div>
                <a target="_blank" :href="getKBLink('report_sales')" class="btn btn-outline-primary text-center mr-2"><i class="tlm-icon-question-circle" /></a>
                <button class="btn btn-outline-primary text-nowrap mr-4" :class="{ active: needUpdate }" @click="loadSales">Построить отчет</button>
            </div>
        </template>
        <dash-graph class="my-5" :range.sync="range" :payment-type.sync="ptype" :chart="chart" />
        <div class="d-flex justify-content-between my-3">
            <div>
                <span class="font-weight-bold">Список продаж</span>
            </div>
        </div>

        <sales-list :sales="sales" :has-crt="hasCrt" :currency="currency" :need-update="needUpdate" />

        <router-view />
    </ThePage>
</template>

<script>
import ThePage from '@/components/ThePage'
import DashGraph from '@/components/DashGraph'
import SalesList from '@/components/SalesList'

import store from '@/store'

import DateCacheService, { oneWeekAgoRange } from '@/services/DateCacheService'
import KBLinksService from '@/services/KBLinksService'

function resolveDefaultRange() {
    return DateCacheService.getFormatted('dash', oneWeekAgoRange)
}

const beforeRoute = async (to, from, next) => {
    if (!to.query.since || !to.query.until) {
        return next({ name: to.name, query: resolveDefaultRange() })
    }
    next()
}

export default {
    components: {
        ThePage,
        DashGraph,
        SalesList
    },

    props: {
        filter: {
            type: Object,
            default: _ => ({ })
        }
    },

    data() {
        return {
            needUpdate: true
        }
    },

    computed: {
        sales() {
            return this.$store.state.sales.data || []
        },

        currency() {
            return this.$store.state.company.profile.data.balance_currency || null
        },

        range: {
            set({ alias, ...range }) {
                alias
                    ? DateCacheService.setAlias('dash', alias)
                    : DateCacheService.set('dash', range)

                this.applyFilter({ ...range, page: 1 })
            },

            get() {
                return this.filter
            }
        },

        ptype: {
            set(ptype) {
                this.applyFilter({ ptype, page: 1 })
            },

            get() {
                return this.filter.ptype || 0
            }
        },

        chart() {
            return this.$store.state.sales.chart || []
        },

        hasCrt() {
            return this.$store.getters['company/hasCrt']
        }
    },

    watch: {
        filter(value) {
            this.needUpdate = true
        }
    },

    methods: {
        async loadSales() {
            await store.dispatch('sales/fetchAll', { params: this.$route.query })
            this.needUpdate = false
        },
        getKBLink(key) {
            return KBLinksService.get(key)
        }
    },

    beforeRouteEnter: beforeRoute,
    beforeRouteUpdate: beforeRoute,

    beforeRouteLeave(to, from, next) {
        store.commit('sales/CLEAR')
        next()
    }
}
</script>
